import { FacebookShareButton } from '../../pkg/Social/Facebook/Share';
import { TwitterShareButton } from '../../pkg/Social/Twitter/Share';
import React from 'react';

// import * as runtime from 'react/jsx-runtime';
// import { evaluate } from '@mdx-js/mdx';

// import useSWR from 'swr';

// import { useSWR } from '../../hooks/useSWR';

import S from './Content.module.css';

export const Content = ({ data: content, children }) => {
  // const {
  //   data: apiResponse,
  //   error,
  //   isLoading
  // } = useSWR(`/api/blog/${url}`, {
  //   initial: data
  // });

  // const [mdx, setMdx] = useState<null | {
  //   default: () => JSX.Element;
  // }>();

  // const apiContent = apiResponse?.data?.content;

  // useEffect(() => {
  //   if (!apiContent) {
  //     return;
  //   }
  //   (async () => {
  //     const res = await evaluate(apiContent, {
  //       ...runtime,
  //       Fragment: React.Fragment,
  //       jsxDEV: runtime.jsx
  //     });
  //     setMdx(res);
  //   })();
  // }, [apiContent]);

  // if (!data || isLoading || error || !apiResponse) {
  //   return null;
  // }

  // const content = apiResponse?.data || data;

  return (
    <article className={S.root}>
      <h1 className={S.title}>{content.title}</h1>
      <div className={S.details}>
        {content.date_published && (
          <span className={S.group}>
            <span className={S.publishDate}>
              {content.date_published?.replace('T', ' ').replace('+00:00', '')}
            </span>
          </span>
        )}
        <span className={S.group}>
          <FacebookShareButton className={S.shareButton} data-type="facebook" />
          <TwitterShareButton
            data-type="twitter"
            className={S.shareButton}
            via="Vasyl_Zubach"
            text={content.title}
          />
        </span>

        {/* <span>{content.date_updated}</span> */}
      </div>
      <hr className={S.divider} />
      <div className={S.content}>{children}</div>
      {/* {mdx ? <mdx.default /> : children} */}
    </article>
  );
};
